import ReactApexChart from "react-apexcharts";
import ITrash from "../../../../models/garbage can/response/trash";
import {
    EGarbageCanType,
    EGarbageCanTypeKeysType,
} from "../../../../models/garbage can/garbageCanType";
import { colorPalette } from "./chartOption";
import { useTranslation } from "react-i18next";

interface OrganicMaterialsProps {
    trash: ITrash;
}

const OrganicMaterialsChart = ({ trash }: OrganicMaterialsProps) => {
    const total = trash.total;
    const compostPercentage = (trash.compost / total) * 100;
    const recyclingPercentage = (trash.recycling / total) * 100;
    const wastePercentage = (trash.waste / total) * 100;
    const colors = colorPalette.slice(0, Object.keys(EGarbageCanType).length);
    const { t } = useTranslation(["sensor"]);

    const chartOptions = {
        labels: [
            t(`waste.${EGarbageCanType.Compost as EGarbageCanTypeKeysType}`),
            t(`waste.${EGarbageCanType.Recycling as EGarbageCanTypeKeysType}`),
            t(`waste.${EGarbageCanType.Waste as EGarbageCanTypeKeysType}`),
        ],
        fill: {
            colors,
        },
        colors,
        markers: {
            colors,
        },
    };

    const chartData = {
        series: [compostPercentage, recyclingPercentage, wastePercentage],
    };

    return (
        <ReactApexChart
            options={chartOptions}
            series={chartData.series}
            type="donut"
            width="100%"
        />
    );
};

export default OrganicMaterialsChart;